/**
 * @file Component: Busy
 * @author yumao<yuzhang.lille@gmail.com>
 */

import {
  Component,
  //Compiler,
  NgModule,
  NgModuleFactory,
  Injectable,
  DoCheck,
  OnDestroy,
} from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'

import { PromiseTrackerService } from './promise-tracker.service'

const inactiveStyle = style({
  opacity: 0,
  transform: 'translateY(-40px)',
})
const timing = '.3s ease'

export interface IBusyContext {
  message: string
}

@Component({
  selector: 'ng-busy',
  template: `
    <div [class]="wrapperClass" *ngIf="isActive$ | async">
      <div style="position: relative; width:100%; height:100%;z-index:909">
        <div class="lds-css">
          <div style="width:100%;height:100%" class="lds-rolling">
            <div></div>
          </div>
        </div>
      </div>
    </div>
  `,
  animations: [
    trigger('flyInOut', [
      transition('void => *', [inactiveStyle, animate(timing)]),
      transition('* => void', [animate(timing, inactiveStyle)]),
    ]),
  ],
})
export class BusyComponent {
  // implements DoCheck, OnDestroy
  TemplateComponent
  private nmf: NgModuleFactory<any>
  wrapperClass: string
  template: string
  message: string
  private lastMessage: string
  isActive$ = this.tracker.isActive$

  constructor(
    private tracker: PromiseTrackerService, //private compiler: Compiler
  ) {}
}
